<template>
  <td
    :class="
      'text-sm p-2 ' +
      container_class +
      (text_align === 'right'
        ? ' text-right'
        : text_align === 'center'
        ? ' text-center'
        : ' text-left')
    "
  >
    <slot></slot>
  </td>
</template>

<script>
export default {
  props: {
    container_class: {
      type: String,
      default: "",
    },
    text_align: {
      type: String,
      default: "left",
    },
  },
};
</script>
